const standardTimeZones = {
  ET: "[-5:00]",
  CT: "[-6:00]",
  MT: "[-7:00]",
  PT: "[-8:00]",
  GMT: "[+0:00]",
  BST: "[+1:00]",
  IST: "[+5:30]",
  AEST: "[+10:00]",
  ACST: "[+9:30]",
  AWST: "[+8:00]",
  JST: "[+9:00]",
  BRT: "[-3:00]",
  CET: "[+1:00]",
  CEST: "[+2:00]",
  MSK: "[+3:00]",
  VLAT: "[+10:00]",
  CST: "[+8:00]",
  SAST: "[+2:00]",
  ART: "[-3:00]",
  SGT: "[+8:00]",
  NZST: "[+12:00]",
  EET: "[+2:00]",
  EEST: "[+3:00]",
};

export default standardTimeZones;
